import { getThemeColor, Styles } from "@mcleod/core";

export const CapturedImageThumbnailStyles = Styles.make("capture-thumbnail", () => {
    return {
        thumbnailContainer: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            borderRadius: "8px",
            overflow: "visible",
            backgroundColor: getThemeColor("defaultBackground"),
            border: `1px solid ${getThemeColor("primary.light")}`
        },
        thumbnailImage: {
            objectFit: "cover",
            width: "100%",
            height: "100%",
            borderRadius: "8px",
            position: "absolute",
            top: "0",
            left: "0"
        },
        deleteButton: {
            position: "absolute",
            top: "-8px",
            right: "-8px",
            borderRadius: "50%",
            backgroundColor: "rgba(215, 53, 69, 1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 999,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)"
        }
    };
});


